module.exports = __webpack_public_path__ + "img/ionicons.b45d332.svg";